<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p">
      <header id="scrn-h">
        <div class="myunichoices-logo">
          <a routerLink="/login">
            <img src="assets/images/myunichoices-logo.png" alt="" />
          </a>
        </div>
        <div class="subtitle-strap">
          {{ locale.introText }}
        </div>
      </header>
      <form
        id="scrn-c"
        [formGroup]="forgottenPasswordForm"
        (ngSubmit)="forgottenPassword(forgottenPasswordForm.value)"
        novalidate="novalidate"
      >
        <div *ngIf="messageCopy" class="alert" role="alert">{{ messageCopy }}</div>
        <div class="form-header">
          <div ngxBalanceText>{{ locale.subtitleText }}</div>
        </div>
        <div class="form-control">
          <input
            (click)="onClickInput()"
            type="email"
            class="input-control"
            [placeholder]="locale.emailPlaceholder"
            [formControl]="forgottenPasswordForm.controls['email']"
          />
          <div
            class="validation-error"
            *ngIf="
              (forgottenPasswordSubmitted || forgottenPasswordForm.controls['email'].dirty) &&
              !forgottenPasswordForm.controls['email'].valid
            "
            [@fadeInOutHeight]
          >
            <div class="form-hint">
              <div>{{ locale.emailValidationText }}</div>
            </div>
          </div>
        </div>
        <div class="form-control">
          <button type="submit" class="input-control button" [disabled]="formSubmitted">
            {{ locale.continueButtonText }}
          </button>
        </div>
      </form>
      <footer id="scrn-f">
        <div class="sign-up">
          {{ locale.loginText }} <a routerLink="/login">{{ locale.loginLinkText }}</a>
        </div>
      </footer>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/forgotten-login/forgotten-login.component.html